'use client'

import {Modal} from '@/components/modals/BaseModal'
import {Button} from '@/components/Button'
import Link from 'next/link'

export const RegistrationStatusSuccess = ({isOpen, userCreated}: {isOpen: boolean; userCreated: boolean}) => {
  const DialogTitle = () => {
    return <p className='text-xl font-semibold text-center text-primary'>{'Thank you for joining!'}</p>
  }
  const DialogDescription = () => {
    return (
      <div className='py-3 text-lg text-center text-gray-500 lg:px-20 xl:px-40'>
        <p>We are thrilled to have you on board. Check your email to view the login link we sent you.</p>
        {!userCreated && (
          <p className='pt-3'>
            An account with the email address you provided <strong>already exists</strong>, so after verifying the link
            you can log in using the <strong>password that was already associated with your account.</strong>
          </p>
        )}
        <p className='pt-3'> We look forward to seeing you around!</p>
      </div>
    )
  }
  const DialogFooter = () => {
    return (
      <div className='flex justify-center'>
        <Link href='/auth/login'>
          <Button>Continue</Button>
        </Link>
      </div>
    )
  }
  return <Modal large open={isOpen} title={<DialogTitle />} body={<DialogDescription />} footer={<DialogFooter />} />
}
